/* istanbul ignore file */
const logger = {
  error(...args) {
    window.console.warn(...args);
  },
};

export default logger;
